// lazy-image/client.js
// Renders lazy-loading images.
import $ from 'jquery';
import radio from 'radio';
import inview from 'lib-unicorn/inview';
import { SCROLL, RENDER_LAZY_IMAGES, RERENDER_ALL } from 'shared/enums/events';

const render = function render($context) {
  const src = $context.data('src');
  const query = {
    url: src,
    w: $context.data('width') || $context.get(0).offsetWidth,
    h: $context.data('height') || $context.get(0).offsetHeight,
    c: 'sc',
    poi: 'face',
    q: 85,
  };

  // Bucket image widths, to take advantage of the image service's caching
  const bucketSize = 100;
  for (let i = 1200; i >= 100; i -= bucketSize) {
    // Round up to the nearest bucket instead of down
    if (query.w + bucketSize > i) {
      query.h = Math.ceil(i * (query.h / query.w));
      query.w = i;
      break;
    }
  }

  // Handle high density displays
  if (window.devicePixelRatio >= 2) {
    query.w *= 2;
    query.h *= 2;
    query.q = 70;
  }

  // On images that might upscale, don't supply height
  if ($context.hasClass('no-upscale')) {
    delete query.h;
  }

  // Prevent any scaling when specified
  if ($context.hasClass('no-scale')) {
    delete query.w;
    delete query.h;
  }

  // If no width or height was determined, remove cropping params
  if (!query.h || !query.w || $context.hasClass('no-crop')) {
    delete query.c;
    delete query.poi;
  }

  // Remove width/height when not determined
  if (!query.w) {
    delete query.w;
  }
  if (!query.h) {
    delete query.h;
  }

  // Don't run image through image service
  const shouldIgnore = (
    src.indexOf('.gif') > -1 ||
    src.indexOf('//rde-') > -1 ||
    src.indexOf('//dev-cdn') > -1 ||
    src.indexOf('dev.') > -1 ||
    (src.indexOf('http:') === -1 && src.indexOf('https:') === -1) ||
    $context.hasClass('skip-imagesvc')
  );

  if ($('#page-keyvals .keyvals').length) {
    const u = $('#page-keyvals .keyvals').data('qa_cdn_username');
    const p = $('#page-keyvals .keyvals').data('qa_cdn_password');
    if (u && p) {
      query.url = query.url.replace('//', `//${encodeURIComponent(u)}:${encodeURIComponent(p)}@`);
    }
  }

  const imageUrl = shouldIgnore ? src : `https://imagesvc.timeincapp.com/v3/mm/image?${$.param(query)}`;
  const dataAlt = $context.data('alt').toString() || '';
  const alt = dataAlt.replace(/"/g, '&quot;');
  const dataWidth = $context.data('width');

  const $newImage = $('<img />')
    .one('error', function handleError() {
      if (this.src !== src) {
        this.src = src;
      }
    })
    .attr('src', imageUrl)
    .attr('alt', alt);

  // Respect image dimensions if specified
  if (dataWidth) {
    $newImage.attr('style', `width: ${dataWidth}px`);
  }

  $context
    .addClass('rendered')
    .find('.js-inner-container')
    .append($newImage);
};

const renderInView = function renderInView() {
  $('.component.lazy-image').each(function iterateImages() {
    const $img = $(this);
    if (!$img.hasClass('rendered') &&
      inview.partiallyInView($img)) {
      render($img);
    }
  });
};

const renderPrintView = function renderPrintView() {
  $('.component.lazy-image').each(function iterateImages() {
    const $img = $(this);
    if (!$img.hasClass('rendered')) {
      render($img);
    }
  });
};

export default function lazyImage() {
  radio(RENDER_LAZY_IMAGES).subscribe(() => renderInView());
  radio(RERENDER_ALL).subscribe(() => renderInView());
  renderInView();

  // Render all images if the user tries to print the page.
  window.onbeforeprint = renderPrintView;

  return radio(SCROLL).subscribe(renderInView);
}



// WEBPACK FOOTER //
// ./~/unicorn/shared/components/lazy-image/client.js